export default "__VITE_ASSET__CWU3E7Nh__"